export default __webpack_public_path__ + "static/media/aleo-v4-latin-regular.f93e6e3c.ttf";